var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobotFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 680,
    viewBox: "0 0 1024 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 0H0V680H1024V0Z",
    fill: "#3D2134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.88 412.73L977 396.44L981 450.19C994.96 456.59 1009.3 462.123 1023.94 466.76C1024.14 447.75 1023.88 412.73 1023.88 412.73Z",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 376.99V432.04L0 409.56V354.27L47.77 376.99Z",
    fill: "#989898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.54 367.25L19 418.22L21.07 419.06L28.77 368.02L26.54 367.25Z",
    fill: "#261421"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M930.61 55.66H107.66V680H930.61V55.66Z",
    fill: "#E8E9F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.85 518.24L47.77 543.64V261.14L107.85 286.54V518.24Z",
    fill: "#E8E9F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M929.65 518.24L989.73 543.64V261.14L929.65 286.54V518.24Z",
    fill: "#E8E9F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M882.73 116.43H152.26V632.8H882.73V116.43Z",
    fill: "#2E1926"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M627.84 7.00998H404.32L378.92 62.89H653.24L627.84 7.00998Z",
    fill: "#E8E9F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M391.6 55.33H639.78",
    stroke: "#C5C6DA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M499.27 7.00998L477.16 62.89H541.37L528.54 7.00998",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M930.2 294.13L930.65 507",
    stroke: "#C5C6DA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.98 294.13L105.43 507",
    stroke: "#C5C6DA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M580.56 0.23999H448.48V7.00999H580.56V0.23999Z",
    fill: "#837392"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M477.16 62.89L900.47 80.74L905.58 309.16L959.69 293.37V530.94L972.57 536.39V277.71L915.06 294.42V62.89H541.37H477.16Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.87 74.48C123.581 74.48 126.59 71.4713 126.59 67.76C126.59 64.0486 123.581 61.04 119.87 61.04C116.159 61.04 113.15 64.0486 113.15 67.76C113.15 71.4713 116.159 74.48 119.87 74.48Z",
    fill: "#C5C6DA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.27 74.48C142.981 74.48 145.99 71.4713 145.99 67.76C145.99 64.0486 142.981 61.04 139.27 61.04C135.559 61.04 132.55 64.0486 132.55 67.76C132.55 71.4713 135.559 74.48 139.27 74.48Z",
    fill: "#C5C6DA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M139.27 63.67V71.94",
    stroke: "#ABACBB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.89 67.81L135.08 67.76",
    stroke: "#ABACBB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.87 63.67V71.94",
    stroke: "#ABACBB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.49 67.81L115.69 67.76",
    stroke: "#ABACBB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.48 405.35L994.94 456.32L997.01 457.17L1004.71 406.13L1002.48 405.35Z",
    fill: "#261421"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotFrame);
export default __webpack_public_path__ + "static/media/robot-frame.bb49abf7f0d23bd8d35368a68b4d8e6c.svg";
export { ForwardRef as ReactComponent };